<p-dialog
  header="Journal des 30 derniers jours"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '800px' }"
  [contentStyle]="{ 'max-height': '75vh', overflow: 'auto' }"
  (onHide)="onDialogHide()"
>
  <div *ngIf="loading" class="flex justify-center p-8">
    <p-progressSpinner ariaLabel="loading" />
  </div>

  <div
    *ngIf="!loading && dayGroups.length === 0"
    class="flex flex-col items-center justify-center text-center p-8"
  >
    <lucide-icon
      name="message-square"
      [size]="50"
      class="text-gray-300 dark:text-gray-200 mb-4"
    ></lucide-icon>
    <p class="text-base text-gray-500 dark:text-gray-200">
      Aucun commentaire de journal pour les 30 derniers jours.
    </p>
  </div>

  <div *ngIf="!loading" class="flex flex-col gap-6">
    <div *ngFor="let day of dayGroups">
      <h3 class="text-sm font-semibold text-color mb-3">
        {{ day.date | date: "fullDate" }}
      </h3>

      <div class="flex flex-col gap-4">
        <div *ngFor="let fl of day.functionalLocations">
          <div class="text-xs font-medium text-muted-color mb-2">
            {{ fl.equipmentName }} ({{ fl.factory }}, {{ fl.plannerGroup }},
            {{ fl.workCenter }})
          </div>

          <div class="flex flex-col gap-2">
            <div
              *ngFor="let message of fl.messages"
              (click)="goToRule(message.ruleUid)"
              class="flex gap-3 p-3 bg-surface-100 dark:bg-surface-700 rounded-lg border-2 border-surface-200 dark:border-surface-600 shadow-sm cursor-pointer hover:border-primary transition-all"
            >
              <div class="flex-1">
                <div class="flex items-center justify-between mb-1">
                  <span class="font-semibold text-sm text-color">{{
                    message.sender
                  }}</span>
                  <span class="text-xs text-muted-color">{{
                    message.sentAt | date: "HH:mm"
                  }}</span>
                </div>
                <div
                  class="text-sm text-color break-all text-justify whitespace-pre-wrap"
                >
                  {{ message.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
